export default function initCollapsibles() {
    setTimeout(function(){
        setInterval(function(){
            var svgs = document.querySelectorAll("svg use[data-href]");
            if(svgs && svgs.length>0) {
                for(var x=0; x < svgs.length; x++) {
                    if(svgs[x]) {
                        var svgDataHref = svgs[x].getAttribute("data-href");
                        if(svgDataHref) {
                            svgs[x].setAttribute("href", svgDataHref);
                        }
                    }
                }
            }
        }, 2000);
    }, 2000);

}
